import { cn } from "@shared/lib/utils";
import { Button } from "@shared/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import {
  Archive,
  Copy,
  Download,
  Edit,
  Eye,
  FileText,
  Plus,
  Settings,
  Share,
  Trash2,
} from "lucide-react";
import React from "react";

type ButtonVariant =
  | "default"
  | "destructive"
  | "outline"
  | "secondary"
  | "ghost"
  | "link";

interface QuickAction {
  label: string;
  icon?: string;
  onClick: () => void;
  variant?: ButtonVariant;
  className?: string;
  disabled?: boolean;
}

interface FacilityQuickActionsSidebarProps {
  title: string;
  description?: string;
  actions: QuickAction[];
  className?: string;
}

const getIcon = (iconName?: string) => {
  const iconMap = {
    edit: Edit,
    copy: Copy,
    "file-text": FileText,
    "trash-2": Trash2,
    plus: Plus,
    eye: Eye,
    download: Download,
    settings: Settings,
    share: Share,
    archive: Archive,
  };

  const IconComponent = iconName
    ? iconMap[iconName as keyof typeof iconMap]
    : null;
  return IconComponent;
};

export const FacilityQuickActionsSidebar: React.FC<
  FacilityQuickActionsSidebarProps
> = ({ title, description, actions, className }) => {
  return (
    <Card className={cn("h-fit", className)}>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">{title}</CardTitle>
        {description && <p className="text-sm text-gray-600">{description}</p>}
      </CardHeader>
      <CardContent className="space-y-2">
        {actions.map((action, index) => {
          const ActionIcon = getIcon(action.icon);

          return (
            <Button
              key={index}
              variant={action.variant || "outline"}
              className={cn("w-full justify-start p-2", action.className)}
              size="sm"
              onClick={action.onClick}
              disabled={action.disabled}
            >
              {ActionIcon && <ActionIcon className="w-4 h-4 mr-2" />}
              {action.label}
            </Button>
          );
        })}
      </CardContent>
    </Card>
  );
};
